import { useEffect, useState } from "react";
import { useIsDesktop } from "./useMediaQuery.js";
import { useShortcut } from "../shortcuts/useShortcut.js";

/**
 * Desktop list-page behaviour shared by every list page:
 * - Table / Cards view choice, remembered per page (phones always get cards)
 * - shortcuts: N = new record, / = focus search, V = switch view
 */
export function useListView(pageKey, { onNew } = {}) {
  const isDesktop = useIsDesktop();
  const storageKey = `books_list_view_${pageKey}`;
  const [view, setView] = useState(() => localStorage.getItem(storageKey) || "table");

  useEffect(() => {
    localStorage.setItem(storageKey, view);
  }, [storageKey, view]);

  const toggleView = () => setView((prev) => (prev === "table" ? "cards" : "table"));

  useShortcut("list_new", () => onNew?.(), { disabled: !onNew });
  useShortcut("list_toggle_view", toggleView);
  useShortcut("list_search", () => {
    const input = document.querySelector(".main-content .search-input");
    input?.focus();
    input?.select();
  });

  return { isDesktop, view, setView, toggleView, showTable: isDesktop && view === "table" };
}

export default useListView;
